"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-page-header", {
    attrs: {
      title: "返回"
    },
    on: {
      back: _vm.goBack
    }
  }), _vm._v(" "), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "flex-end"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.submitForm("ruleForm");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "保存修改" : "立即创建") + " ")])], 1), _vm._v(" "), _c("el-tabs", {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "基本设置",
      name: "first"
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    staticStyle: {
      width: "800px",
      "padding-top": "20px"
    },
    attrs: {
      model: _vm.ruleForm,
      rules: _vm.rules,
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isEdit,
      expression: "isEdit"
    }],
    attrs: {
      label: "店铺",
      prop: "shop_name",
      "label-width": _vm.labelWidth
    }
  }, [_vm._v("\n          " + _vm._s(this.ruleForm.shop) + "\n        ")]), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "产品名称",
      prop: "name",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    model: {
      value: _vm.ruleForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "name", $$v);
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "下单方式",
      prop: "order_mode",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-radio-group", {
    attrs: {
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    model: {
      value: _vm.ruleForm.order_mode,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "order_mode", $$v);
      },
      expression: "ruleForm.order_mode"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("先用后付")]), _vm._v(" "), _c("el-radio", {
    attrs: {
      label: 2
    }
  }, [_vm._v("先付后用")])], 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "成本金额",
      prop: "cost_money",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      type: "number"
    },
    model: {
      value: _vm.ruleForm.cost_money,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "cost_money", $$v);
      },
      expression: "ruleForm.cost_money"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "产品品牌",
      prop: "brand",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    model: {
      value: _vm.ruleForm.brand,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "brand", $$v);
      },
      expression: "ruleForm.brand"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "产品型号",
      prop: "model",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    model: {
      value: _vm.ruleForm.model,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "model", $$v);
      },
      expression: "ruleForm.model"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: "产品分类",
      prop: "goods_cate",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-cascader", {
    attrs: {
      options: _vm.options
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.optionsvalue,
      callback: function callback($$v) {
        _vm.optionsvalue = $$v;
      },
      expression: "optionsvalue"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isEdit == true,
      expression: "isEdit == true"
    }],
    attrs: {
      label: "产品二维码(支付宝)",
      prop: "",
      "label-width": _vm.labelWidth
    }
  }, [_c("img", {
    attrs: {
      src: _vm.qrImg,
      alt: ""
    }
  })]), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "产品图片",
      prop: "good_img",
      "label-width": _vm.labelWidth
    }
  }, [_c("div", {
    staticStyle: {
      color: "red"
    }
  }, [_vm._v("请上传 jpg/jpeg 格式的图片，暂不支持其他格式")]), _vm._v(" "), _c("input", {
    attrs: {
      type: "file",
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    on: {
      change: _vm.handleFileChange
    }
  }), _vm._v(" "), _vm.imageUrl ? _c("div", {
    staticStyle: {
      width: "300px"
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      src: _vm.imageUrl,
      alt: "上传图片"
    }
  })]) : _vm._e()])], 1)], 1), _vm._v(" "), _c("el-tab-pane", {
    attrs: {
      label: "账单设置",
      name: "second"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    staticStyle: {
      width: "800px",
      "padding-top": "20px"
    },
    attrs: {
      model: _vm.ruleForm,
      rules: _vm.rules,
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "扣费方式",
      prop: "cost_type",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-radio-group", {
    attrs: {
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    on: {
      change: _vm.generatePreviewBill
    },
    model: {
      value: _vm.ruleForm.cost_type,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "cost_type", $$v);
      },
      expression: "ruleForm.cost_type"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 3
    }
  }, [_vm._v("周")]), _vm._v(" "), _c("el-radio", {
    attrs: {
      label: 2
    }
  }, [_vm._v("月")]), _vm._v(" "), _c("el-radio", {
    attrs: {
      label: 4
    }
  }, [_vm._v("自定义间隔天数")])], 1)], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.cost_type == 4,
      expression: "ruleForm.cost_type == 4"
    }],
    attrs: {
      label: "扣款间隔天数",
      prop: "cost_type_diy",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      min: 3,
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    on: {
      blur: _vm.generatePreviewBill
    },
    model: {
      value: _vm.cost_type_diy,
      callback: function callback($$v) {
        _vm.cost_type_diy = $$v;
      },
      expression: "cost_type_diy"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v("天")])], 2)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "下单类型",
      prop: "order_type",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-radio-group", {
    attrs: {
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    on: {
      change: _vm.updateRules
    },
    model: {
      value: _vm.ruleForm.order_type,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "order_type", $$v);
      },
      expression: "ruleForm.order_type"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 2
    }
  }, [_vm._v("租赁")]), _vm._v(" "), _c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("缴费")])], 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "首付扣款总额",
      prop: "shou_money",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      min: 1,
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    on: {
      blur: _vm.generatePreviewBill
    },
    model: {
      value: _vm.ruleForm.shou_money,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "shou_money", $$v);
      },
      expression: "ruleForm.shou_money"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: " 首付扣款天数",
      prop: "shou_cost_day",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    on: {
      blur: _vm.generatePreviewBill
    },
    model: {
      value: _vm.ruleForm.shou_cost_day,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "shou_cost_day", $$v);
      },
      expression: "ruleForm.shou_cost_day"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v("天")])], 2)], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      "label-width": _vm.labelWidth,
      prop: "shou_cost_day1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c("el-tooltip", {
          attrs: {
            content: "第一次扣款的日期",
            placement: "top"
          }
        }, [_c("span", [_vm._v("首付-首期扣款日(含当天)")])])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c("el-input", {
    attrs: {
      type: "number",
      min: 1,
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    on: {
      blur: _vm.generatePreviewBill
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_vm._v("天")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.shou_cost_day1,
      callback: function callback($$v) {
        _vm.shou_cost_day1 = $$v;
      },
      expression: "shou_cost_day1"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: " 首付扣款期数",
      prop: "shou_cost_num",
      "label-width": _vm.labelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ruleForm.shou_cost_num) + "\n          ")]), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: "预购订单总金额",
      prop: "money",
      "label-width": _vm.labelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ruleForm.money) + "\n          ")]), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: "预购订单总期数",
      prop: "cost_num",
      "label-width": _vm.labelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ruleForm.cost_num) + "\n          ")]), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: "扣款规则",
      prop: "cost_rule",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      placeholder: "扣款规则将根据预览账单自动生成，无须手动输入",
      disabled: ""
    },
    model: {
      value: _vm.ruleForm.cost_rule,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "cost_rule", $$v);
      },
      expression: "ruleForm.cost_rule"
    }
  })], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "ruledata"
  }, [_c("div", {
    staticClass: "ruletitle"
  }, [_c("div", [_vm._v("预览账单")])]), _vm._v(" "), _c("div", {
    staticClass: "ruleinfobox"
  }, [_c("div", {
    staticClass: "infoitem"
  }, [_vm._v("1、预览账单中的扣款日期根据签约时间动态变化，按照需求设置好日期间隔即可")]), _vm._v(" "), _c("div", {
    staticClass: "infoitem"
  }, [_vm._v("2、最后一个日期至少是"), _c("span", {
    staticStyle: {
      "font-weight": "600",
      "font-size": "20px",
      color: "#ff7221"
    }
  }, [_vm._v(" " + _vm._s(_vm.day45) + " ")]), _vm._v("，否则账单周期不足30天，无法创建商品")]), _vm._v(" "), _c("div", {
    staticClass: "infoitem"
  }, [_vm._v("3、生成初始账单会在正常扣款日前一日生成一笔2元测试扣款，"), _c("span", {
    staticStyle: {
      "font-weight": "600",
      color: "#ff7221"
    }
  }, [_vm._v("第一期2元不可删除，其他期可自行调整")])])]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary",
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    on: {
      click: _vm.generatePreviewBill
    }
  }, [_vm._v("生成初始账单")]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "",
      disabled: _vm.is_checkbill
    },
    on: {
      click: function click($event) {
        _vm.dialogFormVisible = true;
      }
    }
  }, [_vm._v("添加期数")]), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.errorarr.length > 0,
      expression: "errorarr.length > 0"
    }],
    staticStyle: {
      color: "red",
      margin: "10px",
      "padding-left": "10px"
    }
  }, _vm._l(_vm.errorarr, function (item, index) {
    return _c("div", [_vm._v("错误" + _vm._s(index + 1) + "：" + _vm._s(item))]);
  }), 0), _vm._v(" "), _vm._l(_vm.newRuledata, function (item, index) {
    return _c("div", [_c("div", {
      staticClass: "rulecontent"
    }, [_c("div", {
      staticClass: "ruleitem"
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("天数序号")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c("div", {
      staticClass: "ruleitem"
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("扣款日期")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [_c("el-date-picker", {
      attrs: {
        type: "date",
        placeholder: "选择日期",
        format: "yyyy 年 MM 月 dd 日",
        "value-format": "yyyy-MM-dd",
        "picker-options": {
          disabledDate: function disabledDate(time) {
            return time.getTime() < Date.now() + 86400000; // 禁用今天之前的日期
          }
        },
        disabled: _vm.is_checkbill
      },
      on: {
        change: _vm.arrByDate
      },
      model: {
        value: item.date,
        callback: function callback($$v) {
          _vm.$set(item, "date", $$v);
        },
        expression: "item.date"
      }
    })], 1)]), _vm._v(" "), _c("div", {
      staticClass: "ruleitem"
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("扣款金额")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [_c("el-input", {
      attrs: {
        placeholder: "",
        disabled: _vm.is_checkbill
      },
      model: {
        value: item.money,
        callback: function callback($$v) {
          _vm.$set(item, "money", $$v);
        },
        expression: "item.money"
      }
    })], 1)]), _vm._v(" "), _c("div", {
      staticClass: "ruleitem",
      staticStyle: {
        width: "80px"
      }
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("拆单数")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [_vm._v("\n                  " + _vm._s(item.splitnum) + "\n                  "), item.splitnum > 0 && !item.isSplitVisibel ? _c("span", {
      on: {
        click: function click($event) {
          item.isSplitVisibel = true;
        }
      }
    }, [_vm._v("展开 "), _c("i", {
      staticClass: "el-icon-arrow-down"
    })]) : _vm._e(), _vm._v(" "), item.splitnum > 0 && item.isSplitVisibel ? _c("span", {
      on: {
        click: function click($event) {
          item.isSplitVisibel = false;
        }
      }
    }, [_vm._v("收起 "), _c("i", {
      staticClass: "el-icon-arrow-up"
    })]) : _vm._e()])]), _vm._v(" "), _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.is_day_nums,
        expression: "is_day_nums"
      }],
      staticClass: "ruleitem",
      staticStyle: {
        width: "120px"
      }
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("操作")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [item.splitnum > 0 ? _c("el-button", {
      attrs: {
        type: "text",
        disabled: _vm.is_checkbill
      },
      on: {
        click: function click($event) {
          return _vm.cancelsplitmoneyByDate(item);
        }
      }
    }, [_vm._v("取消拆单")]) : _c("el-button", {
      attrs: {
        type: "text",
        disabled: _vm.is_checkbill
      },
      on: {
        click: function click($event) {
          return _vm.splitmoneyByDate(item, 2);
        }
      }
    }, [_vm._v("拆单")]), _vm._v(" "), _c("el-button", {
      attrs: {
        type: "text",
        disabled: _vm.is_checkbill
      },
      on: {
        click: function click($event) {
          return _vm.deleteItem(item);
        }
      }
    }, [_vm._v("删除")])], 1)])]), _vm._v(" "), item.splitnum > 0 && item.isSplitVisibel == true ? _c("div", {
      staticClass: "ruleinfo"
    }, [_c("div", {
      staticStyle: {
        display: "flex",
        "align-items": "center",
        "margin-bottom": "10px",
        "font-size": "14px"
      }
    }, [_vm._v("\n                拆单数："), _c("el-input", {
      staticStyle: {
        width: "100px"
      },
      attrs: {
        type: "number",
        min: 2,
        max: 10,
        disabled: _vm.is_checkbill
      },
      on: {
        blur: function blur($event) {
          return _vm.validateAndSetSplitnum(item);
        }
      },
      model: {
        value: item.tempSplitnum,
        callback: function callback($$v) {
          _vm.$set(item, "tempSplitnum", $$v);
        },
        expression: "item.tempSplitnum"
      }
    }), _vm._v(" "), _c("el-button", {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        type: "primary",
        disabled: _vm.is_checkbill,
        size: "small"
      },
      on: {
        click: function click($event) {
          return _vm.validateAndSetSplitnum(item);
        }
      }
    }, [_vm._v("确定")]), _vm._v(" "), _c("el-button", {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        type: "text",
        size: "small",
        disabled: _vm.is_checkbill
      },
      on: {
        click: function click($event) {
          item.tempSplitnum = 10;
        }
      }
    }, [_vm._v("填入拆单数10")])], 1), _vm._v(" "), _c("el-table", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        data: item.splitmoney
      }
    }, [_c("el-table-column", {
      attrs: {
        label: "序号",
        width: "width",
        type: "index"
      }
    }), _vm._v(" "), _c("el-table-column", {
      attrs: {
        prop: "prop",
        label: "扣款金额",
        width: "width"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [_vm._v("\n                    " + _vm._s(scope.row.money) + "\n                  ")];
        }
      }], null, true)
    }), _vm._v(" "), _c("el-table-column", {
      attrs: {
        prop: "prop",
        label: "扣款日期",
        width: "width"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [_vm._v("\n                    " + _vm._s(scope.row.date) + "\n                  ")];
        }
      }], null, true)
    })], 1)], 1) : _vm._e()]);
  })], 2)], 1), _vm._v(" "), _c("el-dialog", {
    attrs: {
      title: "添加期数",
      visible: _vm.dialogFormVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "login-form mobile-view"
  }, [_c("div", {
    staticClass: "rulecontent"
  }, [_c("div", {
    staticClass: "ruleitem"
  }, [_c("div", {
    staticClass: "itemlabel"
  }, [_vm._v("扣款日期")]), _vm._v(" "), _c("div", {
    staticClass: "itemvalue"
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "选择日期",
      format: "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 86400000; // 禁用今天之前的日期
        }
      },
      disabled: _vm.is_checkbill
    },
    model: {
      value: _vm.split_date,
      callback: function callback($$v) {
        _vm.split_date = $$v;
      },
      expression: "split_date"
    }
  })], 1)]), _vm._v(" "), _c("div", {
    staticClass: "ruleitem"
  }, [_c("div", {
    staticClass: "itemlabel"
  }, [_vm._v("扣款金额")]), _vm._v(" "), _c("div", {
    staticClass: "itemvalue"
  }, [_c("el-input", {
    attrs: {
      placeholder: "",
      disabled: _vm.is_checkbill
    },
    model: {
      value: _vm.split_money,
      callback: function callback($$v) {
        _vm.split_money = $$v;
      },
      expression: "split_money"
    }
  })], 1)])])]), _vm._v(" "), _c("div", {
    staticClass: "getcode",
    staticStyle: {
      width: "300px",
      "margin-left": "150px"
    },
    on: {
      click: function click($event) {
        return _vm.clossPop();
      }
    }
  }, [_vm._v("\n            确认\n          ")])])], 1), _vm._v(" "), _c("el-tab-pane", {
    attrs: {
      label: "其他设置",
      name: "third"
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    staticStyle: {
      width: "800px",
      "padding-top": "20px"
    },
    attrs: {
      model: _vm.ruleForm,
      rules: _vm.rules,
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "押金(原首付款)",
      prop: "deposit",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      type: "number"
    },
    model: {
      value: _vm.ruleForm.deposit,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "deposit", $$v);
      },
      expression: "ruleForm.deposit"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: "提前扣款天数",
      prop: "q_cost_day",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      min: 0
    },
    model: {
      value: _vm.ruleForm.q_cost_day,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "q_cost_day", $$v);
      },
      expression: "ruleForm.q_cost_day"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v("天")])], 2)], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: "到期买断开关",
      prop: "d_cost_type",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.ruleForm.d_cost_type,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "d_cost_type", $$v);
      },
      expression: "ruleForm.d_cost_type"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ruleForm.order_type == 2,
      expression: "ruleForm.order_type == 2"
    }],
    attrs: {
      label: "到期买断价",
      prop: "d_cost_money",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      type: "number"
    },
    model: {
      value: _vm.ruleForm.d_cost_money,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "d_cost_money", $$v);
      },
      expression: "ruleForm.d_cost_money"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "备注提示信息",
      prop: "remark",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    model: {
      value: _vm.ruleForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "remark", $$v);
      },
      expression: "ruleForm.remark"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "待选参数名称",
      prop: "parameter",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "待选参数名称",
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true
    },
    model: {
      value: _vm.ruleForm.parameter,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "parameter", $$v);
      },
      expression: "ruleForm.parameter"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "产品待选参数",
      prop: "parameter_value",
      "label-width": _vm.labelWidth
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "默认待选参数",
      disabled: _vm.ruleForm.active != "拒绝" && _vm.isEdit == true,
      type: "textarea"
    },
    model: {
      value: _vm.ruleForm.parameter_value,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "parameter_value", $$v);
      },
      expression: "ruleForm.parameter_value"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;